import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { WEB_API_URL } from 'services/constants/env';
import { TUserApi } from './types';

export const user: TUserApi = {
	getOrganizations: () =>
		http
			.get(`${WEB_API_URL ?? ''}${endpoint.user.ORGANIZATIONS}`)
			.then((response) => response.data),
	getUserInfo: () => http.get(endpoint.user.USER_INFO).then((response) => response.data),
	getNewMessageCount: () =>
		http.get(endpoint.user.GET_NEW_MESSAGE_COUNT).then((response) => response.data),
	getMessages: () => http.get(endpoint.user.FETCH_MESSAGES).then((response) => response.data),
	markAsReadMessage: (payload) =>
		http
			.post(endpoint.user.MARK_AS_READ_MESSAGE(payload.messageId))
			.then((response) => response.data),
	deleteMessage: (payload) =>
		http.delete(endpoint.user.DELETE_MESSAGE(payload.messageId)).then((response) => response.data),
};
